import { useState, useEffect } from 'react';

export const useDebounce = (value, delay = 1000, count = 3) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (typeof value === 'string' && value.length <= count)
        setDebouncedValue('');
      else setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value]);

  return debouncedValue;
};
